import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=9c7d2556&scoped=true&"
import script from "./Course.vue?vue&type=script&lang=js&"
export * from "./Course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7d2556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9c7d2556', component.options)
    } else {
      api.reload('9c7d2556', component.options)
    }
    module.hot.accept("./Course.vue?vue&type=template&id=9c7d2556&scoped=true&", function () {
      api.rerender('9c7d2556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Course.vue"
export default component.exports